import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";

const OverrideEditDialog = ({
  open,
  onOpenChange,
  formData,
  setFormData,
  schedules,
  handleUpdateRequest,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("planning.overridesPanel.editTitle")}</DialogTitle>
          <DialogDescription>
            {t("planning.overridesPanel.editDescription")}
          </DialogDescription>
        </DialogHeader>

      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label>{t("planning.overridesPanel.requestedSchedule")}</Label>
          <Select
            value={formData.override_schedule_id?.toString()}
            onValueChange={(value) => setFormData({ ...formData, override_schedule_id: parseInt(value) })}
          >
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {schedules.map((s) => (
                <SelectItem key={s.id} value={s.id.toString()}>{s.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t("planning.overridesPanel.priority")}</Label>
          <Select
            value={formData.priority.toString()}
            onValueChange={(value) => setFormData({ ...formData, priority: parseInt(value) })}
          >
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="1">{t("planning.overridesPanel.priorities.low")}</SelectItem>
              <SelectItem value="5">{t("planning.overridesPanel.priorities.medium")}</SelectItem>
              <SelectItem value="10">{t("planning.overridesPanel.priorities.high")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t("planning.overridesPanel.reason")}</Label>
          <Textarea
            value={formData.reason}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
            rows={4}
          />
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="edit-exceptional"
            checked={formData.is_exceptional}
            onCheckedChange={(checked) => setFormData({ ...formData, is_exceptional: checked })}
          />
          <Label htmlFor="edit-exceptional" className="text-sm font-normal">
            {t("planning.overridesPanel.exceptionalShort")}
          </Label>
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>{t("planning.scheduleManager.actions.cancel")}</Button>
        <Button onClick={handleUpdateRequest}>{t("planning.scheduleManager.actions.save")}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  );
};

export default OverrideEditDialog;
